import { createContext } from 'react';

export type FileUploadCtx = {
  showInvalidFileAlert: boolean;
  showInvalidSizeAlert: boolean;
  showFileUploadAlert: boolean;
  fileUploadError: string;
};

const FileUploadContext = createContext<FileUploadCtx>({
  showInvalidFileAlert: false,
  showInvalidSizeAlert: false,
  showFileUploadAlert: false,
  fileUploadError: '',
});

export default FileUploadContext;
